import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IOpbCompanyListState } from '../states/opb-company-list.state';

export const selectOpbCompanyListState = createFeatureSelector<IOpbCompanyListState>('opbCompanyList');

export const selectOpbCompanySearchFilter = createSelector(
  selectOpbCompanyListState,
  (state: IOpbCompanyListState) => state.searchFilter
);

export const selectOpbCompanyPagination = createSelector(
  selectOpbCompanyListState,
  (state: IOpbCompanyListState) => ({
    currentPage: state.currentPage,
    pageSize: state.pageSize
  })
);

export const selectOpbCompanySort = createSelector(
  selectOpbCompanyListState,
  (state: IOpbCompanyListState) => ({
    sortBy: state.sortBy,
    ascending: state.ascending
  })
);

export const selectOpbCompanyListFullState = createSelector(
  selectOpbCompanyListState,
  (state: IOpbCompanyListState) => state
);
